import { motion } from "framer-motion"
import { AnimTap, EColors, EFonts, EVariables } from "libs/style/w24_styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  title: string
  badge?: string
  className?: string
  onClick?: () => void
}

export const CoreButton2 = (props: Props): JSX.Element => {
  return (
    <S_CoreButton2
      className={props.className}
      {...AnimTap}
      onClick={props.onClick}
    >
      <S_Title>{props.title}</S_Title>
      {props.badge && <S_Badge>{props.badge}</S_Badge>}
    </S_CoreButton2>
  )
}

const S_CoreButton2 = styled(motion.div)`
  display: inline-flex;
  padding: 3px 19px 3px 19px;
  height: 46px;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.4);
  width: fit-content;
  cursor: pointer;
  border-radius: ${EVariables.Radius1};
  position: relative;
  flex-shrink: 0;
  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
  @media only screen and (min-width: 1260px) {
    padding: 11px 22px 11px 22px;
    height: 62px;
  }
`
const S_Title = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Medium};
  font-size: 15px;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
    font-family: ${EFonts.Bold};
  }
`

const S_Badge = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Medium};
  font-size: 12px;
  background-color: ${EColors.WHITE};
  border-radius: ${EVariables.Radius1};
  padding: 1px 7px;
  position: absolute;
  right: 10px;
  top: -8px;
  @media only screen and (min-width: 1260px) {
    padding: 3px 10px 3px 10px;
    right: 15px;
    top: -10px;
    font-size: 14px;
  }
`
